import React from 'react';
import './App.css';
import GenerateImage from './components/generateImage';

function App() {
  return (
    <GenerateImage />
  );
}

export default App;
